/* eslint-disable import/no-anonymous-default-export */
export default (locationYearlyQuantity = [], action) => {
  switch (action.type) {
    case "LOCATION_STOCK_ISSUED_YEARLY":
      return action.payload;

    default:
      return locationYearlyQuantity;
  }
};
